import React, { useState } from "react";
import { motion } from "framer-motion";
import ConsultationModal from "../Modal/ConsultationModal";

const Outro = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className="bg-white py-16 px-5 md:px-10 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 gap-8 items-center">

            {/* Content */}
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: -60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >

              <motion.h1
                className="font-bold text-4xl md:text-3xl lg:text-5xl text-primary mb-4"
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                viewport={{ once: true }}
              >
                Stop Doing Everything Yourself
              </motion.h1>

              <motion.h3
                className="text-black text-lg md:text-xl font-medium mb-3"
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                viewport={{ once: true }}
              >
                You don't need more time. You need better support.
              </motion.h3>

              <motion.p
                className="text-black text-base md:text-lg mb-6 leading-relaxed"
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                viewport={{ once: true }}
              >
                Let GDesk handle the operations, so you can focus on growing
                your business.
              </motion.p>

              <motion.button
                onClick={() => setOpenModal(true)}
                className="bg-primary text-white md:text-sm px-6 md:px-8 py-3 rounded-lg font-semibold shadow border border-primary hover:bg-white hover:text-primary transition-colors duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                Book a Free Consultation
              </motion.button>
            </motion.div>

            {/* Image */}
            {/* <motion.div
              className="hidden lg:flex justify-center items-center"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <motion.img
                src={GDeskTeam}
                alt="GDesk Team"
                className="w-full max-w-md h-auto object-contain rounded-lg drop-shadow-lg"
              />
            </motion.div> */}

          </div>
        </div>
      </div>

      {/* Modal */}
      <ConsultationModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};

export default Outro;